import { render, staticRenderFns } from "./SubscriptionInfo.vue?vue&type=template&id=1faba0f1&scoped=true&"
import script from "./SubscriptionInfo.vue?vue&type=script&lang=js&"
export * from "./SubscriptionInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionInfo.vue?vue&type=style&index=0&id=1faba0f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faba0f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VRow})
